import { useEffect, useRef } from 'react';
import type { SidebarTabId } from '../types';

/**
 * LayoutContext.sidebarTab → the workspace's remembered tab (QAP tab pinning and the panels that switch the tab through
 * the layout). Only a real change of the layout's tab counts — not the tab it had at mount: the remembered ui-state is
 * the source then (WorkspaceContext bridges it into the layout). When the two stored tabs differed at load, this sync
 * and that bridge swapped them every commit until React gave up (error #185, owner 28.10: layout «journal», ui-state
 * «plan» — the table crashed on every entry). A ref, not a «first run» flag: StrictMode runs effects twice.
 */
export function useLayoutTabSync(layoutTab: string, activeTab: SidebarTabId, setActiveTab: (tab: SidebarTabId) => void): void {
  const lastLayoutTab = useRef(layoutTab);
  useEffect(() => {
    if (layoutTab === lastLayoutTab.current) return;
    lastLayoutTab.current = layoutTab;
    if (layoutTab && layoutTab !== activeTab) setActiveTab(layoutTab as SidebarTabId);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [layoutTab]);
}
